import * as React from 'react';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { formulierPageContainerClassName } from '../constants/values';
import { FormulierContainer } from '../container/FormulierContainer';
import { FieldFactory } from '../form/factory/fieldFactory';
import { IForm } from '../form/interface/form';
import { IFormContentDataViewModel } from '../form/interface/formContentData';
import { SimpleFormMapper } from '../form/mapper/SimpleFormMapper';
import { FormulierenContentService } from '../form/service/FormulierenContentService';
import { FormJsonModifier } from '../form/utils/FormJsonModifier';
import { IFormProps } from '../interfaces/IFormProps';

export const FormulierPage = (props: Readonly<IFormProps>) => {
  const simpleFormMapper = new SimpleFormMapper(new FieldFactory());
  const simpleForm = props.formDefinition;
  const form: IForm = simpleFormMapper.mapSimpleForm(simpleForm);
  const formulierenContentService = new FormulierenContentService(props.apiUrl);
  const [cmsAllFormsContentResult, setAllFormsContentResult] = React.useState<IFormContentDataViewModel | null>(null);
  const [cmsSpecificFormContentResult, setSpecificFormContentResult] = React.useState<IFormContentDataViewModel | null>(
    null
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const allFormsContent = await formulierenContentService.getGenericCmsContent(props.language);
        setAllFormsContentResult(allFormsContent);
        const specificFormContent = await formulierenContentService.getSpecificCmsContent(
          props.formulierKenmerk,
          props.language
        );
        setSpecificFormContentResult(specificFormContent);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const formJsonModifier = new FormJsonModifier();

  if (cmsAllFormsContentResult) {
    formJsonModifier.addCmsContentToJsonDefinitionfunction(form, cmsAllFormsContentResult);
  }
  if (cmsSpecificFormContentResult) {
    formJsonModifier.addCmsContentToJsonDefinitionfunction(form, cmsSpecificFormContentResult);
    document.title = `CAK - ${cmsSpecificFormContentResult.title}`;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  const thankYouPageContent = cmsSpecificFormContentResult?.thankYouContent
    ? cmsSpecificFormContentResult.thankYouContent
    : cmsAllFormsContentResult?.thankYouContent;

  return (
    <div className={`${formulierPageContainerClassName}`}>
      <FormulierContainer
        {...props}
        formJsonSchema={form}
        thankYouPageContent={thankYouPageContent}
        downloadInformationContent={cmsAllFormsContentResult?.downloadInformation}
      />
    </div>
  );
};
